import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Style from "./CreatePublicDiscountCode.module.scss";
import { Alert } from "antd";
import DatePicker from "@amir04lm26/react-modern-calendar-date-picker";
import { createPublicDiscountApi } from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { Spinner } from "react-bootstrap";
import { jalaliToUnixTimestamp } from "../../../Utils/jalaliToUnixTimestamp/jalaliToUnixTimestamp";

const CreatePublicDiscountCode = ({ mode, detail, updateHanlder }) => {
  const [selectedDay, setSelectedDay] = useState();
  const [selectedDay2, setSelectedDay2] = useState();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    setLoading(true);
    const start_date = `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`;
    const end_date = `${selectedDay2.year}/${selectedDay2.month}/${selectedDay2.day}`;
    const StartDateTimeStamp = jalaliToUnixTimestamp(start_date);
    const endDateTimeStamp = jalaliToUnixTimestamp(end_date);
    let bodyDetail = {
      action: mode === "Edit" ? "update" : "add",
      id: mode === "Edit" ? detail.id : null,
      type: data.discountType,
      discount: data.discount,
      value: data.value,
      start_date: StartDateTimeStamp,
      end_date: endDateTimeStamp,
      min_cart: data.discountType === "const" ? data.min_cart : 0,
      max_cart: data.discountType === "const" ? 0 : data.max_cart,
      usage_limit: data.usage_limit,
    };
    createPublicDiscountApi(bodyDetail, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast(res.message);
          setLoading(false);
        } else {
          succToast("با موفقیت ایجاد شد!");
          setLoading(false);
          mode === "Edit" && updateHanlder();
        }
      } else {
        console.error(res);
        setLoading(false);
      }
    });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={Style.FormHolder}
      {...register("type")}
    >
      <label htmlFor="">
        نوع تخفیف 
        <select
          {...register("discountType", {
            required: mode === "Edit" ? false : true,
          })}
          className={Style.selectHolder}
          disabled={mode === "Edit"}
          defaultValue={mode === "Edit" ? detail.typeEncrypted : null}
        >
          <option value="const">مقدار ثابت</option>
          <option value="percentage">درصد</option>
          <option value="shipping">ارسال</option>
        </select>
        {errors.discountType && (
          <span style={{ color: "red" }}>این فیلد الزامی است</span>
        )}
      </label>
      <label htmlFor="">
        {`کد تخفیف (حروف کوچک وارد کنید)`}
        <input
          placeholder="کد را وارد کنید"
          {...register("discount", {
            required: mode === "Edit" ? false : true,
          })}
          disabled={mode === "Edit"}
          defaultValue={mode === "Edit" ? detail.discount : null}
        />
        {errors.discount && (
          <span style={{ color: "red" }}>این فیلد الزامی است</span>
        )}
      </label>
      <label htmlFor="">
        مقدار تخفیف!
        <input
          placeholder="مقدار را وارد کنید"
          {...register("value", { required: mode === "Edit"|| watch("discountType") === "shipping" ? false : true })}
          disabled={mode === "Edit" || watch("discountType") === "shipping"}
          defaultValue={mode === "Edit" ? detail.value : null}
        />
        {errors.value && (
          <span style={{ color: "red" }}>این فیلد الزامی است</span>
        )}
      </label>
      <label htmlFor="">
        تاریخ شروع تخفیف
        <DatePicker
          value={selectedDay}
          onChange={setSelectedDay}
          shouldHighlightWeekends
          locale="fa" // add this
        />
      </label>
      <label htmlFor="">
        تاریخ پایان تخفیف
        <DatePicker
          value={selectedDay2}
          onChange={setSelectedDay2}
          shouldHighlightWeekends
          locale="fa" // add this
        />
      </label>
      {watch("discountType") === "percentage" ? (
        <label htmlFor="">
          حداکثر سبد خرید!
          <input
            placeholder="حداکثر مقدار سبد خرید را وارد کنید"
            {...register("max_cart")}
            disabled={mode === "Edit"}
            defaultValue={mode === "Edit" ? detail.max_cart : null}
          />
        </label>
      ) : (
        <label htmlFor="">
          حداقل سبد خرید!
          <input
            placeholder="حداقل مقدار سبد خرید را وارد کنید"
            {...register("min_cart")}
            disabled={mode === "Edit"}
            defaultValue={mode === "Edit" ? detail.min_cart : null}
          />
        </label>
      )}
      <label htmlFor="">
        تعداد قابل استفاده!
        <input
          placeholder="تعداد را وارد کنید"
          {...register("usage_limit", {
            required: mode === "Edit" ? false : true,
          })}
          defaultValue={mode === "Edit" ? detail.usage_limit : null}
        />
        {errors.usage_limit && (
          <span style={{ color: "red" }}>این فیلد الزامی است</span>
        )}
      </label>

      <Alert
        message=" توجه"
        description="درصورت انتخاب درصد عدد وارد شده در مقدار تخفیف به عنوان درصد تخفیف در نظر گرفته می شود!"
        type="error"
        showIcon
        className={Style.AlertHolder}
      />
      <button type="submit" className={Style.buttonHolder} disabled={loading}>
        {loading ? <Spinner animation="border" color="#fff" /> : "ثبت"}
      </button>
    </form>
  );
};

export default CreatePublicDiscountCode;
